module.exports = __webpack_public_path__ + "static/media/nz.d1b4ba58.hdr";